import React, { useState } from "react";
import { FiBriefcase, FiCheckCircle, FiFileText, FiUser } from "react-icons/fi";
import logo from "../../assets/images/logo.png";

import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useForm, Controller } from "react-hook-form";
import useHooks from "./useHooks";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { accountSendOtp, verifyOtp, deleteAccountApi } = useHooks();

  const {
    register,
    handleSubmit,
    control,
    clearErrors,
    formState: { errors },
  } = useForm();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);

  const steps = [
    { id: 1, title: "Login", icon: <FiUser size={20} /> },
    { id: 2, title: "OTP", icon: <FiBriefcase size={20} /> },
    { id: 3, title: "Delete Account", icon: <FiFileText size={20} /> },
  ];

  const onSubmit = async (data) => {
    if (currentStep === 1) {
      const resp = await accountSendOtp({ email: data.email });
      if (resp?.status) {
        setEmail(data.email);
        setCurrentStep(2);
      }
    }
  };
  
  const handlePrev = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  const handleOTPSubmit = async () => {
    const code = otp.join("");
    const resp = await verifyOtp({ email, otp: code });
    if (resp?.status) {
      setCurrentStep(3);
    }
  };

  const handleOtpChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    if (e.target.value && index < 3) {
      const nextField = document.getElementById(`otp-${index + 1}`);
      nextField?.focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prevField = document.getElementById(`otp-${index - 1}`);
      prevField?.focus();
    }
  };

  const handleConfirmDelete = async () => {
    const resp = await deleteAccountApi();
    setShowDeleteModal(false);
    if (resp?.status) {
      localStorage.clear();
      navigate("/");
    }
  };

  return (
    <div className="container">
      <div className="flex items-center justify-center min-h-screen ">
        <div className="w-full sm:w-3/4 md:w-2/3 lg:w-2/5 bg-white rounded-lg ">
          <img
            className="cursor-pointer w-36 mx-auto mb-6"
            src={logo}
            alt="logo"
          />

          {/* Stepper */}

          <div className="flex items-center mb-8 relative w-full">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className="flex flex-col justify-center w-full"
              >
                <div className="flex items-center w-full">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full border-2 ${currentStep > step.id
                        ? "border-secondaryText bg-secondaryText"
                        : currentStep === step.id
                          ? "border-secondaryText bg-white text-secondaryText"
                          : "border-grayDarkText bg-white text-grayDarkText"
                      }`}
                  >
                    {currentStep > step.id ? (
                      <FiCheckCircle className="text-white" />
                    ) : (
                      step.icon
                    )}
                  </div>

                  {/* Connecting Line */}
                  {index < steps.length - 1 && (
                    <div
                      className={`flex-1 h-[3px] ${currentStep > step.id
                          ? "bg-secondaryText"
                          : "bg-grayDarkText"
                        }`}
                    ></div>
                  )}
                </div>

                {/* Step Title */}
                <p
                  className={`mt-2 text-xs text-start font-medium ${currentStep >= step.id
                      ? "text-secondaryText"
                      : "text-gray-500"
                    }`}
                >
                  {step.title}
                </p>
              </div>
            ))}
          </div>

          {currentStep === 1 && (
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
              <div className="flex justify-center my-3">
                <p className="text-2xl text0-blackie font-medium">
                Delete your Account
                </p>
              </div>
              <div className="flex flex-col gap-2 ">
                <label className="text-labelTextColor text-lg">
                  Email address
                </label>
                <div className="w-full h-[51px] flex items-center px-3 rounded-lg border border-borderColor">
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Please enter a valid email address",
                      },
                    })}
                    className="w-full h-full px-3 outline-none"
                    onChange={(e) => {
                      clearErrors("email");
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                {errors.email && (
                  <span className="text-red-500 text-sm">
                    {errors.email.message}
                  </span>
                )}
              </div>

              <div className="flex justify-between mt-6">
                <button
                  type="button"
                  disabled={currentStep === 1}
                  onClick={handlePrev}
                  className="h-12 px-4 rounded-full border border-gray-300 text-gray-600 disabled:opacity-50"
                >
                  Previous
                </button>
                <button
                  type="submit"
                  className="h-12 px-6 bg-darkBg rounded-full text-white hover:bg-secondaryText transition"
                >
                  Next
                </button>
              </div>
            </form>
          )}

          {/* Form for Step 2: OTP */}
          {currentStep === 2 && (
            <div>

              <h3 className="text-2xl text-center text-blackie font-medium ">
                Enter OTP
              </h3>
              <p className="text-lg text-center text-blackie ">
                Verify your account by entering verification code we sent to{" "}
                <span className="text-lg text-primaryText font-medium">
            {email}
                </span>
              </p>

              <div className="flex items-center flex-col gap-3 mt-4">

                <div className="flex justify-center space-x-2 sm:space-x-3">
                  {[0, 1, 2, 3].map((index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength={1}
                      value={otp[index]}
                      className="w-12 h-12 text-center text-xl border rounded-lg"
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleBackspace(e, index)}
                      id={`otp-${index}`}
                    />
                  ))}
                </div>
              </div>
              <div className="flex justify-between mt-6">
                <button
                  type="button"
                  onClick={handlePrev}
                  className="h-12 px-4 rounded-full border border-gray-300 text-gray-600"
                >
                  Previous
                </button>
                <button
                  type="button"
                  onClick={handleOTPSubmit}
                  className="h-12 px-6 bg-darkBg rounded-full text-white hover:bg-secondaryText transition"
                >
                  Submit OTP
                </button>
              </div>
            </div>
          )}

          {currentStep === 3 && (
            <div>
              <div className="flex flex-col gap-2 justify-center items-center">
                <p className="text-2xl text-blackie font-medium">
                  Delete Account
                </p>
                <p className="text-labelTextColor text-lg text-center">
                  Your account will be permanently deleted from alldevices and
                  Learn Local Platform.
                </p>
              </div>
              <div className="flex justify-between mt-6">
                <button
                  type="button"
                  onClick={handlePrev}
                  className="h-12 px-4 rounded-full border border-gray-300 text-gray-600"
                >
                  Previous
                </button>
                <button
                  type="button"
                  onClick={() => setShowDeleteModal(true)}

                  className="h-12 px-6 bg-redBg  rounded-full text-white hover:bg-red-700 transition"
                >
                  Delete Account
                </button>
              </div>
              {showDeleteModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg p-6 w-full sm:w-[330px] shadow-lg">
                    <h2 className="text-xl font-semibold text-center text-black mb-4">Confirm Delete</h2>
                    <p className="text-center text-gray-700 mb-6">
                      Are you sure you want to delete your account?
                    </p>
                    <div className="flex justify-between">
                      <button
                        className="h-10 px-4 rounded-full border border-gray-300 text-gray-600"
                        onClick={() => setShowDeleteModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="h-10 px-6 bg-redBg text-white rounded-full hover:bg-red-700 transition"
                        onClick={handleConfirmDelete}
                      >
                        Confirm Delete
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;